import { useGrants, usePersonLinks } from '@/db/hooks'
import { useNow } from '@/hooks/useNow'
import { ringsLine, ringsOn } from '@/lib/ringsToo'
import { cx } from './ui'
import { useAccess } from '@/state/access'

/**
 * "Rings on Keira’s phone too", under a task's reminder when it is with
 * someone whose login covers the task's suite (lib/ringsToo.ts). The owner's
 * devices only: a member's app has no People and no grants.
 */
export const RingsToo = ({ taskId, ws, className }: { taskId: string; ws?: string; className?: string }) => {
  const member = useAccess((s) => s.member)
  const people = usePersonLinks().get(taskId)
  const grants = useGrants()
  const now = useNow()
  const line = member || !people ? null : ringsLine(ringsOn(people, grants, ws, now))
  if (!line) return null
  return (
    <p className={cx('text-xs text-muted', className)} data-testid="rings-too">
      {line}
    </p>
  )
}
